export default __webpack_public_path__ + "../staticImages/familie_tisch-260.png";